"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
const ListItem = props => {
  const {
    children = '',
    className,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
    className: className
  }, others), children);
};
var _default = exports.default = ListItem;